import type { IconSvgObject } from './types';

const LockSync02Icon: IconSvgObject = [
  ["path", { d: "M21.2154 16.0002C19.6684 19.532 16.1355 22.0002 12.0247 22.0002C6.48823 22.0002 2 17.5231 2 12.0002C2 6.47738 6.48823 2.00023 12.0247 2.00023C17.2229 2.00023 21.497 5.94691 22 11.0002L19.5 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.9286 11.3079V9.39C13.9286 8.34618 13.0651 7.5 12 7.5C10.9349 7.5 10.0714 8.34618 10.0714 9.39V11.3079M12 16.5C10.3431 16.5 9 15.1837 9 13.56C9 11.9363 10.3431 10.62 12 10.62C13.6569 10.62 15 11.9363 15 13.56C15 15.1837 13.6569 16.5 12 16.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LockSync02Icon;
